(function ($,window,document) {
    $(function() {
        if ($('section.form .free-pass-wizard, .campaign-content, #workoutFinder, #nearby-gyms-form-module').length > 0) {
            let locationsJson,
                $passLocationFinder,
                searchQuery,
                geoCoder,
                geoLat,
                geoLng,
                geoRad,
                resultsHtml,
                resultsPicked,
                map_locations,
                finalResultsList,
                $passWizard,
                $passStep1,
                $passStep2,
                $passStep3,
                $passStep3club,
                $passStep3online,
                $passForm,
                $newtonType,
                $moduleType,
                formTitle,
                formType,
                campaignForm,
                map_marker_target,
                map_marker_target_icon,
                map_marker_icon,
                mapResults,
                resultsPlaced = [],
                map_country_default = false,
                map_infowindow,
                modals = {};

            if (mapGlobalOptions && mapGlobalOptions.location_bias_center) {
                let addresses_array = mapGlobalOptions.location_bias_center.address.split(/[\s,]+/);
                map_country_default = addresses_array[addresses_array.length - 1];
            }

            // Submit search via current location
            $('#currentLocation').click(function () {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        searchQuery = position.coords.latitude + ', ' + position.coords.longitude;
                        $passLocationFinder.find('#locationFinderInput').val(searchQuery);
                        window.history.pushState('step2', 'Search for: ' + searchQuery, '?location=' + searchQuery);
                        checkLocation(position.coords, 'latlng');
                    });
                } else {
                    alert(translations.geolocationWarning);
                }
            });

            function getJsonData(url = document.location.origin + appOptions.map.jsonPath) {
                let json = null;
                jQuery.ajax({
                    'async': false,
                    'global': false,
                    'url': url,
                    'dataType': "json"
                }).done(function (data) {
                    json = data;
                }).fail(function (jqXHR, textStatus, errorThrow) {
                    console.log(textStatus + ": " + errorThrow);
                });
                return json;
            }

            $passLocationFinder = $('#locationFinder');
            $passWizard = $('.free-pass-wizard');
            $passStep1 = $passWizard.find('.step.step1');
            $passStep2 = $passWizard.find('.step.step2');
            $passStep3 = $passWizard.find('.step.step3');

            if ($('#mapResultsContainer').length > 0) {
                mapResults = new google.maps.Map(document.getElementById('mapResultsContainer'));
            }
            if ($('.campaign-content').length > 0) {
                campaignForm = 'legacy';
                formTitle = 'Campaign Form';
                formType = 'campaign';
                locationsJson = getJsonData(document.location.origin + appOptions.map.campaignJsonPath);
                if ($('#form-newton-trial').length > 0) {
                    campaignForm = 'newton';
                    $passLocationFinder = $('#locationFinderCampaign');
                    $passWizard = $('#locationFinderCampaign');
                    $passStep1 = $passWizard.find('#find_a_gym');
                    $passStep2 = $('#locations');
                    $passStep3 = $('.form-container');
                    $passStep3club = $passStep3;
                    $passStep3online = $passStep3;
                    $newtonType = $('section#form').attr('class');
                } else if ($('#form-blackfriday-landing').length > 0) {
                    campaignForm = 'blackfriday';
                    $passLocationFinder = $('#locationFinderCampaign');
                    $passWizard = $('#locationFinderCampaign');
                    $passStep1 = $passWizard.find('#find_a_gym');
                    $passStep2 = $('#results');
                    $passStep3 = $('.form-container');
                    $passStep3club = $passStep3;
                    $passStep3online = $passStep3;
                } else if ($('#form-seasonal-landing').length > 0) {
                    campaignForm = 'seasonal';
                    $passLocationFinder = $('#locationFinderCampaign');
                    $passWizard = $('#locationFinderCampaign');
                    $passStep1 = $passWizard.find('#find_a_gym');
                    $passStep2 = $('#results');
                    $passStep3 = $('.form-container');
                    $passStep3club = $passStep3;
                    $passStep3online = $passStep3;
                } else if ($('#locationFinderCampaign').length > 0) {
                    campaignForm = 'new';
                    $passLocationFinder = $('#locationFinderCampaign');
                    $passWizard = $('#locationFinderCampaign');
                    $passStep1 = $passWizard.find('#find_a_gym');
                    $passStep2 = $passWizard.find('#locations');
                    $passStep3club = $('#campaignClubForm').find('#register_at_club');
                    $passStep3online = $passWizard.find('#register_online');
                    mapResults.setOptions({disableDefaultUI: true, zoom: search_zoom});
                } else {
                    $passForm = $passStep3.find('.form-body');
                    $passStep3club = $passForm;
                    $passStep3online = $passForm;
                }
            }
            if ($('#nearby-gyms-form-module').length > 0) {
                campaignForm = 'module';
                formTitle = 'Nearby Gyms Module';
                formType = 'campaign';
                $moduleType = $('#nearby-gyms-form-module').data('type');
                locationsJson = getJsonData(document.location.origin + appOptionsOverride.map.jsonPathCustom);
                $passLocationFinder = $('#locationFinderCampaign');
                $passWizard = $('#locationFinderCampaign');
                $passStep1 = $passWizard.find('#find_a_gym');
                $passStep2 = $('#results');
                $passStep3 = $('.form-container');
                $passStep3club = $passStep3;
                $passStep3online = $passStep3;
            }
            if ($('section.form .free-pass-wizard').length > 0) {
                formType = 'free-pass';
                locationsJson = getJsonData();
                formTitle = "Free Trial Pass Form";
                $passForm = $passStep3.find('form'); // for sites using form wizard on forms other than ndp
                $passStep3club = $passForm;
            }
            if ($('#workoutFinder').length > 0) { // possibly deprecated, not sure if international uses this
                $passWizard = $('#FindYourGym');
                $passLocationFinder = $('#workoutFinder');
                $passStep1 = $passLocationFinder;
                $passStep2 = $passWizard.find('#workoutList');
                formType = 'workout-finder';
                locationsJson = getJsonData();
                formTitle = "Workout Finder";
            }
            if ($('#locationFinder').length > 0) {
                // Submit search via clicking Next
                $passStep1.find('.step-footer .btn-step').click(function () {
                    searchQuery = $passLocationFinder.find('#locationFinderInput').val();
                    checkLocation(searchQuery);
                });

                //Return to first pass-wizard step.
                //Return to second pass-wizard step.
                $passWizard.find('.step.step2, .step.step3').on('click', '.btn-cancel, .btn-clear', function (event) {
                    event.preventDefault();
                    window.history.back();
                    if (parseFloat(mapGlobalOptions.force_nday_pass_flow) === 1 && $("#page-headline").length) {
                        $("#page-headline").html($("#page-headline").data('new-header'));
                    }
                });

                AFMap.prototype.setZoom = function () {
                    google.maps.event.trigger(this.map, 'resize');
                    this.map.setZoom(search_zoom);
                };

                function clearActiveClub() {
                    resultsPicked = false;
                    $passStep2.find('.wizard-results > li').each(function () {
                        if (campaignForm == 'module' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                            $(this).removeClass('d-block');
                        } else {
                            $(this).show().removeClass('active');
                        }
                    });
                }

                $passStep3.find('.btn-clear').not('.cancel-link').click(function (e) {
                    e.preventDefault();
                    $passStep3.removeClass('active');
                    $passStep2.addClass('active').removeClass('complete');
                    clearActiveClub();
                });
            }

            function backToStep1() {
                if (campaignForm == 'module' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                    $passStep2.removeClass('d-block');
                    $passStep1.addClass('d-block').find('input').first().focus();
                } else {
                    $passStep2.removeClass('complete active');
                    $passStep1.addClass('active').removeClass('complete').find('input').first().focus();
                }
                $('.ajax-loader', $passStep1).removeClass('active');
                closeMapResults();
                $(window).scrollTop(0);
            }

            function backToStep2() {
                if ($('section.promo-bar').length > 0) {
                    $('section.promo-bar').show();
                    $(window).trigger('resize');
                }
                $passStep1.removeClass('active').addClass('complete');
                $passStep2.find('.wizard-results > li').removeClass('active').attr('tabindex','0');
                if (campaignForm == 'module' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                    $passStep2.addClass('d-block').find('a').first().focus();
                    if ($moduleType == 'form' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') $passStep3.hide();
                } else {
                    $passStep2.removeClass('complete').addClass('active').find('a').first().focus();
                    $passStep3.removeClass('active').attr('tabindex','-1');
                }
                $(window).scrollTop(0);
            }

            function backToStep3() {
                if (campaignForm == 'module' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                    $passStep2.removeClass('d-block').find('.wizard-results > li').attr('tabindex','-1');
                    if ($moduleType == 'form' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') $passStep3.show();
                } else {
                    $passStep2.removeClass('active').addClass('complete').find('.wizard-results > li').attr('tabindex','-1');
                    $passStep3.addClass('active');
                }
            }

            $('.map-results .map-results-close').click(function () {
                closeMapResults();
                if (jQuery('div.free-pass-wizard').length > 0 ) {
                    jQuery('.free-pass-wizard .wizard-results').removeAttr('style');
                }
            });

            function closeMapResults() {
                clearActiveClub();
                $('#mapResults').show();
                $passStep2.find('.map-results').removeClass('active');
            }

            //Return to first pass-wizard step.
            $passStep2.on('click', '.btn-cancel', function (event) {
                event.preventDefault();
                $passStep2.removeClass('complete active');
                $passStep1.addClass('active').removeClass('complete');
                $('.ajax-loader', $passStep1).removeClass('active');
                if (jQuery('div.free-pass-wizard').length > 0 ) {
                    jQuery('.free-pass-wizard .wizard-results').removeAttr('style');
                }
                closeMapResults();
                $(window).scrollTop(0);
            });

            function checkPassUrl(passurl) {
                if (passurl.length < 1) {
                    return false;
                }
                let clubDomain = passurl.replace('http://', '').replace('https://', '').split('/');
                return clubDomain[0] !== location.hostname;
            }

            // Hide error msg
            $passLocationFinder.find('#locationFinderInput').focus(function () {
                if ($passLocationFinder.find('.error-msg').hasClass('active')) {
                    $passLocationFinder.find('.error-msg').removeClass('active');
                }
            });

            /**
             * Handler for run search after user actions.
             */
            let runSearch = function () {
                if ($("#acResultsList").length && $passLocationFinder.find('#locationFinderInput').val().indexOf(',') == -1) {
                    searchQuery = $('body').find("#acResultsList li.result-item.first-child").data('prediction');
                    $passLocationFinder.find('#locationFinderInput').val(searchQuery);
                } else {
                    searchQuery = $passLocationFinder.find('#locationFinderInput').val();
                }
                if (searchQuery.indexOf(',') == -1 && map_country_default) { // add country to address if needing
                    searchQuery = searchQuery + ', ' + map_country_default;
                }
                // Snippet: Free Trial Step 1
                if (formType == 'free-pass') {
                    let delay = 1000;
                    let attempt = 1;
                    let timerId = setTimeout(function request() {
                        if (jQuery("ul.wizard-results li").length > 0 || attempt >= 5) {
                            (window.dataLayer=window.dataLayer||[]).push({
                                'event' : 'free_trial_step_1',
                                'search_location': searchQuery,
                                'search_results': (attempt >= 5 ? 0 : jQuery("ul.wizard-results li").length)
                            });
                        } else {
                            attempt += 1;
                            timerId = setTimeout(request, delay);
                        }
                    }, delay);
                }
                // end Snippet: Free Trial Step 1
                // Blackfriday/Seasonal Campaign Page: Location Search Started
                if (formType == 'campaign' && (campaignForm == 'blackfriday' || campaignForm == 'seasonal') && typeof analytics != "undefined") {
                    analytics.track("Location Search Started", {
                        "brand": 			"anytimefitness",
                        "brand_channel": 	"website",
                        "query":            searchQuery,
                        "page_name": 		document.title,
                        "page_path": 		window.location.href
                    });
                }
                // end Blackfriday/Seasonal Campaign Page: Location Search Started
                checkLocation(searchQuery);
            };

            // Submit event blocked by preventDefault() because it has conflict with autoComplete.addListener('place_changed', ...) - run twice
            $passLocationFinder.submit(function (event) {
                event.preventDefault();
                if ($passLocationFinder.find('#locationFinderInput').val().length > 0) {
                    runSearch();
                } else {
                    $passLocationFinder.find('#locationFinderInput').focus();
                }
                return false;
            });

            // Submit search via clicking Next
            $passStep1.find('.step-footer .btn-step').click(runSearch);

            // Run search via search button.
            $passLocationFinder.find('[type="button"]').click(runSearch);
            $passStep2.find('.btn-clear').click(function (e) {
                e.preventDefault();
                $passStep2.removeClass('active');
                $passStep1.addClass('active').removeClass('complete');
            });

            $('#mapResults').click(function (e) {
                e.preventDefault();
                $passStep2.find('.wizard-results > li').each(function () {
                    $(this).removeClass('active');
                });
                clearActiveClub();
                $passStep2.find('.map-results').addClass('active');
                $(this).hide();
                $("#listResults").show();
                if (jQuery('div.free-pass-wizard').length > 0) {
                    if (window.innerWidth <= 767) {
                        jQuery('.free-pass-wizard .wizard-results').attr('style', 'max-height: 409px; overflow-y: hidden; z-index: 2;');
                    } else {
                        jQuery('.free-pass-wizard .wizard-results').attr('style', 'z-index: 2;');
                    }
                }
            });
            $('#mapResults').keydown(function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    $passStep2.find('.wizard-results > li').each(function () {
                        $(this).removeClass('active');
                    });
                    clearActiveClub();
                    $passStep2.find('.map-results').addClass('active');
                    $(this).hide();
                    $("#listResults").show();
                }
            });
            $('#listResults').keydown(function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    clearActiveClub();
                    $passStep2.find('.map-results').removeClass('active');
                    $("#listResults").hide();
                    $("#mapResults").show();
                }
            });
            $('.map-results .map-results-close, #listResults').click(function (e) {
                e.preventDefault();
                clearActiveClub();
                $passStep2.find('.map-results').removeClass('active');
                $("#listResults").hide();
                $("#mapResults").show();
            });

// Function to run ajax request for locations
            function getLatLngMatches(geoLat, geoLng, geoRad = 0) {
                if (geoLat && geoLng) {
                    if (locationsJson.length > 0 && locationsJson !== 'No Results') {
                        map_locations = [];
                        $(locationsJson).each(function () {
                            let marker_distance,
                                map_center_lat = geoLat,
                                map_center_lng = geoLng,
                                marker_lat = this.latitude,
                                marker_lng = this.longitude,
                                map_distance_units = mapGlobalOptions.site_distance_units;
                            if (map_distance_units === 'miles') {
                                marker_distance = calculateMiles(map_center_lat, map_center_lng, marker_lat, marker_lng);
                            } else if (map_distance_units === 'kilometers') {
                                marker_distance = calculateKilometers(map_center_lat, map_center_lng, marker_lat, marker_lng);
                            }
                            if (marker_distance >= 0 && (!geoRad || marker_distance <= geoRad)) {
                                this.distance = marker_distance.toFixed(1);
                                map_locations.push(this);
                            }
                        });
                        map_locations.sort(function (a, b) {
                            let a_distance = parseFloat(a.distance),
                                b_distance = parseFloat(b.distance);
                            if (a_distance > b_distance) {
                                return 1;
                            }
                            if (a_distance < b_distance) {
                                return -1;
                            }
                            return 0;
                        });
                        finalResultsList = geoRad ? map_locations : map_locations.slice(0, 10);
                        if (formType == 'workout-finder') {
                            buildWorkoutResults(finalResultsList);
                        } else {
                            buildResults(finalResultsList);
                            if (campaignForm == 'module' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                                $passStep2.addClass('d-block');
                                $passStep3.hide();
                            } else {
                                $passStep2.show().addClass('active');
                            }
                            if (campaignForm != 'newton' && campaignForm != 'module' && campaignForm != 'blackfriday' && campaignForm != 'seasonal') {
                                $passStep1.removeClass('active').addClass('complete').find('#intro').hide();
                                initMap(finalResultsList);
                            } else {
                                $('.steps .marker.step1').removeClass('active').addClass('complete');
                                $('.steps .marker.step2').removeClass('incomplete').addClass('active');
                                $('.steps .bridge.step2').addClass('active');
                            }
                            $passLocationFinder.find('.ajax-loader').removeClass('active');
                            if (formType == 'campaign' && campaignForm != 'newton' && campaignForm != 'module' && campaignForm != 'blackfriday' && campaignForm != 'seasonal') {
                                $passStep2.find('.map-results').addClass('active');
                            }
                        }
                    } else {
                        if (formType == 'workout-finder') {
                            showNoWorkoutsError();
                        } else {
                            showNoResultsError();
                        }
                    }
                    if ($('#acResultsList').length) {
                        $('#acResultsList').hide();
                    }
                }
            }

            function showNoResultsError() {
                $passLocationFinder.find('.ajax-loader').removeClass('active');
                $passLocationFinder.find('.error-msg.error-empty').addClass('active');
            }

            function showNoWorkoutsError() {
                jQuery('#workoutList').prepend('<div class="gym-count"><h3 class="text-center"><h3 class="text-center">' + translations.noParticipatingGyms + '</h3><p class="sub-headline text-center">' + translations.pleaseTryDifferent + '</p></h3></div>');
                jQuery('#workoutFinder').find('.ajax-loader').removeClass('active');
                if (jQuery('#acResultsList').length) {
                    jQuery('#acResultsList').hide();
                }
            }

// Check search value, geocode it and continue search
            function checkLocation(searchQuery, searchType = 'address') {
                $passLocationFinder.find('.error-msg').removeClass('active');
                $passLocationFinder.find('.ajax-loader').addClass('active');
                geoRad = $('input[name="search-radius"]').val();
                if (searchType == 'place') {
                    getLatLngMatches(searchQuery.location.lat(), searchQuery.location.lng(), geoRad);
                } else if (searchType == 'latlng') {
                    getLatLngMatches(searchQuery.latitude, searchQuery.longitude, geoRad);
                } else {
                    if (searchQuery.length > 0) {
                        window.history.pushState('step2', 'Search for: ' + searchQuery, '?location=' + searchQuery);
                        geoCoder = new google.maps.Geocoder();
                        geoCoder.geocode({address: searchQuery}, function (results, status) {
                            if (status == google.maps.GeocoderStatus.OK) {
                                geoLat = results[0].geometry.location.lat();
                                geoLng = results[0].geometry.location.lng();
                                getLatLngMatches(geoLat, geoLng, geoRad);
                            } else if (status == google.maps.GeocoderStatus.ZERO_RESULTS) {
                                $passLocationFinder.find('#locationFinderInput').focus();
                                showNoResultsError();
                            }
                        });
                    } else {
                        $passLocationFinder.find('#locationFinderInput').focus();
                        $passLocationFinder.find('.error-msg.error-required').addClass('active');
                    }
                }
            }

            function buildResultsHtml(resultAddress, result) {
                if(result.content.phone == null) {
                    result.content.phone = "";
                }

                let htmlReturn = '<li tabindex="0" data-redirect-to-club-site ' +
                    'data-club-id="' + result.content.number + '" ' +
                    'data-location-club-id="' + result.content.number + '" ' +
                    'data-location-name="' + result.content.title + '" ' +
                    'data-location-address="' + result.content.address + '" ' +
                    'data-location-address2="' + result.content.address2 + '" ' +
                    'data-location-address-full="' + result.content.address + (result.content.address2 ? ' ' + result.content.address2 : '') + '" ' +
                    'data-location-city="' + result.content.city + '" ' +
                    'data-location-country="' + result.content.country + '" ' +
                    'data-location-state="' + result.content.state + '" ' +
                    'data-location-state-abbr="' + result.content.state_abbr + '" ' +
                    'data-location-zip="' + (result.content.zip ?? '') + '" ' +
                    'data-location-url="' + result.content.url + '" ' +
                    'data-location-passlength="' + result.content.pass_length + '" ' +
                    'data-location-phone="' + result.content.phone + '" ' +
                    'data-location-email="' + result.content.email + '" ' +
                    'data-is-closed="' + (result.content.is_temp_closed ? true : false) + '" ' +
                    'data-join-online="' + (result.content.is_join_online ? result.content.join_online_url : false) + '" ';
                if (result.content.join_online_promo_plan_url) {
                    htmlReturn += 'data-join-online-promo-plan-url="' + result.content.join_online_promo_plan_url + '" ';
                }
                htmlReturn += 'data-no-pass-form="' + (result.content.no_7_day ? true : false) + '" ' +
                    'data-location-passurl="' + (result.content.is_temp_closed || result.content.no_7_day ? '' : (result.content.pass_url ? result.content.pass_url : '')) + '" ' +
                    'data-location-websiteurl="' + (result.content.website_url ? result.content.website_url : '') + '" ' +
                    'data-location-passcustom="' + (result.content.is_temp_closed || result.content.no_7_day ? 'false' : (result.content.pass_url ? 'true' : 'false')) + '">';

                if (formType == 'free-pass') {
                    let temporarilyClosedLabel = result.content.is_temp_closed ? ' <span class="emergency-closed-hours">(' + translations.temporarilyClosed + ')</span>' : '';
                    htmlReturn += '<a href="#" tabindex="-1"><h3 class="link-text">' + result.content.title + temporarilyClosedLabel + '<span class="distance">' + result.distance + ' ' + mapGlobalOptions.site_distance_units + '</span></h3>' +
                        '<p>' + resultAddress + '<br>' + result.content.phone + '</p></a>';
                } else if (formType == 'campaign') {
                    let statusLabel = result.content.status == '2' ? ' ' + translations.openingSoon : '';
                    if ($newtonType == 'subscriber' || campaignForm == 'module' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                        htmlReturn += '<div class="location-details">';
                    }
                    htmlReturn += '<h3' + (campaignForm != 'newton' && campaignForm != 'module' && campaignForm != 'blackfriday' && campaignForm != 'seasonal' ? ' class="link-text"' : '') + '>' + (campaignForm == 'seasonal' || $('.need-revert-cta').length ? '<a class="external-link" href="'+result.content.url+'">' : '') + result.content.title + (campaignForm == 'seasonal' || $('.need-revert-cta').length ? '</a>' : '') + statusLabel;
                    if (campaignForm == 'newton' || campaignForm == 'module' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                        htmlReturn += '<span class="distance">' + result.distance + ' ' + mapGlobalOptions.site_distance_units + '</span>';
                    }
                    htmlReturn += '</h3>' +
                        '<p>' + (campaignForm != 'newton' && campaignForm != 'module' && campaignForm != 'blackfriday' && campaignForm != 'seasonal' ? result.content.phone + '<br>' : '') + resultAddress + '</p>';
                    if ($newtonType == 'subscriber') {
                        htmlReturn += '</div>' +
                            '<div class="location-cta"><a class="btn btn-sm btn-primary" href="#">Join in Gym</a>' +
                            (result.content.is_fitness_plan_enabled ? '<a class="btn btn-sm btn-outline-primary external-link" href="'+result.content.fitness_plan_url+'">Join Online</a>' : '') +
                            '</div>';
                    } else if (campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                        if ($('.feature-check-list-bp-small').length && (typeof result.content.is_join_online !== 'undefined') && result.content.is_join_online) {
                            htmlReturn += '</div>' +
                                '<a class="btn btn-sm btn-primary external-link" href="' + result.content.join_online_url + '">Join Online</a>' +
                                '</div>';
                        } else {
                            htmlReturn += '</div>' +
                                '<div class="location-cta"><a class="btn btn-sm btn-outline-primary" href="#">Join in Gym</a>';
                            if (campaignForm == 'blackfriday') {
                                htmlReturn += (result.content.is_blackfriday_plan_enabled ? '<a class="btn btn-sm btn-primary external-link" href="'+result.content.blackfriday_plan_url+'">Join Online</a>' : '');
                            } else if (campaignForm == 'seasonal') {
                                htmlReturn += (result.content.is_seasonal_plan_enabled ? '<a class="btn btn-sm btn-primary external-link" href="'+result.content.seasonal_plan_url+'">Join Online</a>' : '');
                            }
                            htmlReturn += '</div>';
                        }
                    } else if (campaignForm == 'module') {
                        let trialPassUrl = "#";
                        if ($moduleType != 'form') trialPassUrl = appOptions.dynamicURLs.tryUsFreePage+'?club='+result.content.number;
                        if ($('.need-revert-cta').length) { // January Campaign - 2025 | National Offer Page
                            htmlReturn += '</div>' +
                                '<div class="location-cta"><a data-link-type="'+moduleOptions.btn1.link+'" class="btn btn-sm btn-outline-primary'+(moduleOptions.btn1.link != 'gym_page' ? '' : ' external-link')+'" href="'+(moduleOptions.btn1.link == 'trial_pass' ? trialPassUrl : result.content.url)+'">'+moduleOptions.btn1.text+'</a>' +
                                (moduleOptions.btn2.link && moduleOptions.btn2.text ? '<a data-link-type="'+moduleOptions.btn2.link+'" class="btn btn-sm btn-primary'+($moduleType != 'form' ? '' : ' external-link')+'" href="'+(moduleOptions.btn2.link == 'trial_pass' ? trialPassUrl : result.content.url)+'">'+moduleOptions.btn2.text+'</a>' : '') +
                                '</div>';
                        } else {
                            htmlReturn += '</div>' +
                                '<div class="location-cta"><a data-link-type="'+moduleOptions.btn1.link+'" class="btn btn-sm btn-outline-primary'+(moduleOptions.btn1.link != 'gym_page' ? ' external-link' : '')+'" href="'+(moduleOptions.btn1.link == 'trial_pass' ? trialPassUrl : result.content.url)+'">'+moduleOptions.btn1.text+'</a>' +
                                (moduleOptions.btn2.link && moduleOptions.btn2.text ? '<a data-link-type="'+moduleOptions.btn2.link+'" class="btn btn-sm btn-primary'+($moduleType != 'form' ? ' external-link' : '')+'" href="'+(moduleOptions.btn2.link == 'trial_pass' ? trialPassUrl : result.content.url)+'">'+moduleOptions.btn2.text+'</a>' : '') +
                                '</div>';
                        }
                    }
                }
                htmlReturn += '</li>';
                return htmlReturn;
            }

            function buildResults(results) {
                resultsHtml = '';
                $(results).each(function () {
                    let loc_address = this.content.address,
                        loc_address2 = this.content.address2 ? this.content.address2 : '',
                        loc_address_full = loc_address + (loc_address2 ? ' ' + loc_address2 : ''),
                        loc_city = this.content.city,
                        loc_country = this.content.country,
                        loc_state = this.content.state,
                        loc_state_abbr = this.content.state_abbr,
                        loc_zip = this.content.zip ?? '';
                    let resultAddress = loc_address_full + '<br>' + loc_city + ', ' + loc_state_abbr + ' ' + loc_zip;
                    if (address_format) {
                        $.each(address_format, function (index, format) {
                            if (format.country_select === loc_country) {
                                resultAddress = format.format.replace('{{address}}', loc_address)
                                    .replace('{{address2}}', loc_address2)
                                    .replace('{{city}}', loc_city)
                                    .replace('{{state}}', loc_state)
                                    .replace('{{state_abbr}}', loc_state_abbr)
                                    .replace('{{zip}}', loc_zip)
                                    .replace('{{country_abbr}}', loc_country);
                            }
                        });
                    }
                    resultsHtml += buildResultsHtml(resultAddress, this);
                });
                app.importClubs(results); // set up our redirect object
                $passStep2.find('.wizard-results').html(resultsHtml);
                $passStep2.find('.wizard-results').on('click touch keydown', '> li', function (event) {
                    if (!event.target.classList.contains('external-link')) {
                        if (event.type != 'keydown') {
                            event.preventDefault();
                        }
                        if (!$(this).hasClass('active')) {
                            if (event.type != 'keydown' || (event.type == 'keydown' && event.keyCode == 13)) {
                                let isLocal = false;
                                if (mapGlobalOptions.franchisee_country_code == 'QC' && 0 <= mapGlobalOptions.site_country_code.indexOf( $(this).data('location-country') )) {
                                    isLocal = ($(this).data('location-country') == 'CA' && $(this).data('location-state-abbr') == 'QC');
                                } else {
                                    isLocal = 0 <= mapGlobalOptions.site_country_code.indexOf( $(this).data('location-country') ) && $(this).data('location-state-abbr') != 'QC';
                                }
                                if (isLocal) {
                                    $(this).addClass('active');

                                    if (formType == 'campaign' && campaignForm == 'module' && ($moduleType != 'form' || $(event.target).data('link-type') == 'gym_page')) {
                                        window.location = $(this).data('location-url');
                                    } else if (checkPassUrl($(this).data('location-passurl')) === false || formType != 'free-pass') {
                                        // Snippet: Snippet: Free Trial Step 2
                                        if (formType == 'free-pass') {
                                            (window.dataLayer=window.dataLayer||[]).push({
                                                'event' : 'free_trial_step_2',
                                                'club_id': $(this).data('location-club-id'),
                                                'club_name': $(this).data('location-name')
                                            });
                                            if ($(".special-privacy").length) {
                                                if ($('.special-privacy.'+ $(this).data('location-state-abbr') + '.replace').length) { // if there is a div with .special-privacy + code + .replace: hide all other and show this one
                                                    $('.form-notes:not(.special-privacy.' + $(this).data('location-state-abbr') + '.replace)').hide();
                                                    $('.form-group.local-requirements-questions:not(.special-privacy.' + $(this).data('location-state-abbr') + '.replace)').hide();
                                                    $('.form-group.special-privacy:not(.' + $(this).data('location-state-abbr') + '.replace)').hide();
                                                    $('.special-privacy.' + $(this).data('location-state-abbr') + '.replace').show();
                                                } else if ($('.special-privacy.'+ $(this).data('location-state-abbr') + '.add').length) { // if there is a div with .special-privacy + code + .add: hide all other and show default + this one
                                                    $('.special-privacy').hide();
                                                    $('.form-notes:not(.special-privacy)').show();
                                                    $('.form-group.local-requirements-questions:not(.special-privacy)').show();
                                                    $('.special-privacy.' + $(this).data('location-state-abbr') + '.add').show();
                                                } else { // else hide all .special-privacy and show default
                                                    $('.special-privacy').hide();
                                                    $('.form-notes:not(.special-privacy)').show();
                                                    $('.form-group.local-requirements-questions:not(.special-privacy)').show();
                                                }
                                            }
                                        }
                                        // end Snippet: Snippet: Free Trial Step 2
                                        // Blackfriday/Seasonal Campaign Page: Lead Location Selected
                                        if (formType == 'campaign' && (campaignForm == 'blackfriday' || campaignForm == 'seasonal')) {
                                            if (typeof analytics != "undefined") {
                                                analytics.track("Lead Location Selected", {
                                                    "brand": 			"anytimefitness",
                                                    "brand_channel": 	"website",
                                                    'location_id':      $(this).data('location-club-id'),
                                                    'location_name':    $(this).data('location-name'),
                                                    "search_type":      "list",
                                                    "page_name": 		document.title,
                                                    "page_path": 		window.location.href
                                                });
                                            }
                                            if ($('.feature-check-list-bp-small').length) { //  join online landing page
                                                (window.dataLayer=window.dataLayer||[]).push({
                                                    'event' : 'join_online_select_location',
                                                    'club_id':      $(this).data('location-club-id'),
                                                    'club_name':    $(this).data('location-name'),
                                                });
                                                return false;
                                            } else {
                                                (window.dataLayer=window.dataLayer||[]).push({ //  blackfriday
                                                    'event' : (campaignForm == 'blackfriday' ? 'blackfriday' : 'seasonal_offer') + '_select_location',
                                                    'club_id':      $(this).data('location-club-id'),
                                                    'club_name':    $(this).data('location-name'),
                                                });
                                            }
                                        }
                                        // end Blackfriday/Seasonal Campaign Page: Lead Location Selected
                                        setActiveClub(
                                            $(this).data('location-club-id'),
                                            $(this).data('location-name'),
                                            $(this).data('location-address'),
                                            $(this).data('location-address2'),
                                            $(this).data('location-city'),
                                            $(this).data('location-country'),
                                            $(this).data('location-state'),
                                            $(this).data('location-state-abbr'),
                                            $(this).data('location-zip'),
                                            $(this).data('location-url'),
                                            $(this).data('location-passlength'),
                                            $(this).data('location-phone'),
                                            $(this).data('location-email'),
                                            $(this).data('location-is-closed'),
                                            $(this).data('location-no-pass-form')
                                        );
                                        if (formType == 'campaign') {
                                            updateCustomCampaignLinks($(this).data('location-club-id'));
                                            $("h3.jf122-header-h3").hide();
                                            if (campaignForm != 'module' && campaignForm != 'blackfriday' && campaignForm != 'seasonal') {
                                                $('#map, #search_unit').hide();
                                            }
                                            if (campaignForm != 'newton' && campaignForm != 'module' && campaignForm != 'blackfriday' && campaignForm != 'seasonal') { $(this).addClass('active').siblings().hide(); }
                                            if (campaignForm == 'new') {
                                                $('#find_a_gym_title').addClass('sr-only');
                                                $('#search_again').fadeIn();
                                                if ($(this).data('location-campaign') == false || $(this).data('location-campaign') == undefined) {
                                                    $passStep3 = $passStep3club;
                                                } else {
                                                    $passStep3 = $passStep3online;
                                                    $('#request_info').fadeIn();
                                                    $passStep3.find('a[data-action="signup"]').attr('href', $(this).data('location-campaignurl'));
                                                }
                                            }
                                            if (formType == 'campaign' && campaignForm == 'legacy') {
                                                if ($(".special-privacy").length) {
                                                    if ($('.special-privacy.'+ $(this).data('location-state-abbr') + '.replace').length) { // if there is a div with .special-privacy + code + .replace: hide all other and show this one
                                                        $('.form-notes:not(.special-privacy.' + $(this).data('location-state-abbr') + '.replace)').hide();
                                                        $('.form-group.local-requirements-questions:not(.special-privacy.' + $(this).data('location-state-abbr') + '.replace)').hide();
                                                        $('.form-group.special-privacy:not(.' + $(this).data('location-state-abbr') + '.replace)').hide();
                                                        $('.special-privacy.' + $(this).data('location-state-abbr') + '.replace').show();
                                                    } else if ($('.special-privacy.'+ $(this).data('location-state-abbr') + '.add').length) { // if there is a div with .special-privacy + code + .add: hide all other and show default + this one
                                                        $('.special-privacy').hide();
                                                        $('.form-notes:not(.special-privacy)').show();
                                                        $('.form-group.local-requirements-questions:not(.special-privacy)').show();
                                                        $('.special-privacy.' + $(this).data('location-state-abbr') + '.add').show();
                                                    } else { // else hide all .special-privacy and show default
                                                        $('.special-privacy').hide();
                                                        $('.form-notes:not(.special-privacy)').show();
                                                        $('.form-group.local-requirements-questions:not(.special-privacy)').show();
                                                    }
                                                }
                                            }
                                            $passStep3.fadeIn();
                                        } else {
                                            if ($('section.promo-bar').length > 0) {
                                                $('section.promo-bar').hide();
                                                $(window).trigger('resize');
                                            }
                                        }
                                        window.history.pushState('step3', formTitle, "?club=" + $(this).data('location-club-id'));
                                        if (campaignForm == 'newton' || campaignForm == 'module' || campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                                            if ($(".special-privacy").length) {
                                                if ($('.special-privacy.'+ $(this).data('location-state-abbr') + '.replace').length) { // if there is a div with .special-privacy + code + .replace: hide all other and show this one
                                                    $('.form-notes:not(.special-privacy.' + $(this).data('location-state-abbr') + '.replace)').hide();
                                                    $('.form-group.local-requirements-questions:not(.special-privacy.' + $(this).data('location-state-abbr') + '.replace)').hide();
                                                    $('.form-group.special-privacy:not(.' + $(this).data('location-state-abbr') + '.replace)').hide();
                                                    $('.special-privacy.' + $(this).data('location-state-abbr') + '.replace').show();
                                                } else if ($('.special-privacy.'+ $(this).data('location-state-abbr') + '.add').length) { // if there is a div with .special-privacy + code + .add: hide all other and show default + this one
                                                    $('.special-privacy').hide();
                                                    $('.form-notes:not(.special-privacy)').show();
                                                    $('.form-group.local-requirements-questions:not(.special-privacy)').show();
                                                    $('.special-privacy.' + $(this).data('location-state-abbr') + '.add').show();
                                                } else { // else hide all .special-privacy and show default
                                                    $('.special-privacy').hide();
                                                    $('.form-notes:not(.special-privacy)').show();
                                                    $('.form-group.local-requirements-questions:not(.special-privacy)').show();
                                                }
                                            }
                                            if (campaignForm == 'newton') {
                                                $passStep1.hide();
                                                $passStep2.hide().find('.wizard-results > li').attr('tabindex','-1');
                                                $passStep3.show();
                                                $('.steps .marker.step2').removeClass('active').addClass('complete');
                                                $('.steps .marker.step3').removeClass('incomplete').addClass('active');
                                                $('.steps .bridge.step3').addClass('active');
                                            } else {
                                                $passStep2.removeClass('d-block').find('.wizard-results > li').attr('tabindex','-1');
                                                $passStep3.show();
                                            }
                                        } else {
                                            $passStep2.removeClass('active').addClass('complete').find('.wizard-results > li').attr('tabindex','-1');
                                            $passStep3.addClass('active');
                                        }
                                    } else if ($(this).data('location-passcustom') === true) {
                                        window.location = $(this).data('location-passurl');
                                    } else {
                                        window.location = $(this).data('location-websiteurl');
                                    }
                                } else {
                                    new AFRedirectToClubSiteModal($(this).data('location-club-id')).show();
                                }
                                setTimeout(() => {$passStep3.find('button,input,textarea,a').first().focus();},500);
                            }
                        }
                    }
                });
            }

            function buildWorkoutResults(results) {
                $passStep2.find('.search-results-list').html('');
                if ($passStep2.find('.gym-count').length > 0) {
                    $passStep2.find('.gym-count').remove();
                    $passStep2.find('.table').hide();
                }

                // Show results element and animate to it
                $passStep2.show();
                jQuery('html, body').animate({
                    scrollTop: $passStep2.offset().top
                }, 500);

                $passStep2.prepend(
                    '<div class="gym-count"><h3 class="text-center">' + translations.found + ' ' + results.length + ' ' + translations.gymsParticipatingNearby + '</h3></div>'
                );
                jQuery.each(results, function () {
                    $passStep2.find('.search-results-list').append('<tr><td><p>' + this.content.city + ', ' + this.content.state_abbr + '</p></td><td><p>' + this.content.address + '</p></td>' +
                        '<td><p>' + this.content.phone + '</p></td><td><a class="link-text" href="' + this.content.url + '" target="_blank">' + translations.gymWebsite + '</a></td></tr>'
                    );
                });
                $passStep2.find('.table').show();
                $passStep1.find('.ajax-loader').removeClass('active');
                if (jQuery('#acResultsList').length) {
                    jQuery('#acResultsList').hide();
                }
            }

            function initMap(locations) {
                let currentActivePin,
                    resultsBounds = new google.maps.LatLngBounds();
                $(locations).each(function () {
                    let that = $(this)[0],
                        resultLatLng = new google.maps.LatLng(
                            parseFloat(that.latitude),
                            parseFloat(that.longitude)
                        ),
                        mapPin = setCustomPins(that.content.status),
                        resultMarker = new google.maps.Marker({
                            content: that.content,
                            position: resultLatLng,
                            map: mapResults,
                            animation: google.maps.Animation.DROP,
                            active: false,
                            icon: mapPin,
                            campaign: (that.content.campaign ? that.content.campaign : false),
                            campaignUrl: (that.content.campaignUrl ? that.content.campaignUrl : false)
                        });
                    resultsPlaced['marker' + that.content.number] = resultMarker;
                    google.maps.event.addListener(resultMarker, 'mouseover', function () {
                        if ($(this)[0].active !== true) {
                            let mapPin = setCustomPins(that.content.status, 'hover');
                            resultMarker.setIcon(mapPin);
                        }
                    });
                    google.maps.event.addListener(resultMarker, 'mouseout', function () {
                        if ($(this)[0].active !== true) {
                            let mapPin = setCustomPins(that.content.status);
                            resultMarker.setIcon(mapPin);
                        }
                    });
                    google.maps.event.addListener(resultMarker, 'click', function (e) {
                        if (currentActivePin) {
                            currentActivePin.active = false;
                            map_marker_icon = setCustomPins(currentActivePin.content.status);
                            currentActivePin.setIcon(map_marker_icon);
                        }
                        let resultClicked = $(this)[0],
                            resultAfNumber = resultClicked.content.number,
                            result = resultsPlaced['marker' + resultAfNumber],
                            mapPin;
                        if (formType == 'free-pass') {
                            this.map.panTo(this.position);
                            openInfoWindow(this);
                        }
                        if (result.active !== true) {
                            currentActivePin = this;
                            result.active = true;
                            mapPin = setCustomPins(result.content.status, 'active');

                            if (formType == 'campaign') {
                                $("h3.jf122-header-h3").hide();
                                setActiveClub(result.content.number, result.content.title, result.content.address, result.content.address2, result.content.city, result.content.country, result.content.state,
                                    result.content.state_abbr, (result.content.zip ?? ''), result.content.url, result.content.pass_length, result.content.phone, result.content.email, result.content.temp_closed, result.content.no_ndaypass);
                                if (campaignForm != 'newton' && campaignForm != 'module' && campaignForm != 'blackfriday' && campaignForm != 'seasonal') { $('.wizard-results li[data-club-id=' + resultAfNumber + ']').addClass('active').siblings().hide(); }
                                if (campaignForm == 'new') {
                                    $('#map, #search_unit').hide();
                                    $passStep2.removeClass('active').addClass('complete');
                                    $('#find_a_gym_title').addClass('sr-only');
                                    $('#search_again').fadeIn();
                                    if (result.campaign == false) {
                                        $passStep3 = $passStep3club;
                                    } else {
                                        $passStep3 = $passStep3online;
                                        $('#request_info').fadeIn();
                                        $passStep3.find('a[data-action="signup"]').attr('href', result.campaignUrl);
                                    }
                                } else {
                                    $passStep2.removeClass('active').addClass('complete').find('.wizard-results > li').attr('tabindex','-1');
                                    $passStep3.addClass('active');
                                }
                                window.history.pushState('step3', "Campaign Form", "?club=" + result.content.number);
                                updateCustomCampaignLinks(result.content.number);
                                setTimeout(() => {$passStep3.fadeIn().find('button,input,textarea,a').first().focus();},500);
                            }
                        } else {
                            result.active = false;
                            mapPin = setCustomPins(result.content.status);
                            clearActiveClub();
                        }
                        result.setIcon(mapPin);
                    });
                    resultsBounds.extend(resultLatLng);
                });
                mapResults.fitBounds(resultsBounds);

                let template_results = jQuery('.wizard-results');

                jQuery(template_results).on('mouseover', 'li', function () {
                    map_marker_target = resultsPlaced['marker' + jQuery(this).data('clubId')];
                    map_marker_target_icon = setCustomPins(map_marker_target.content.status, 'hover');
                    map_marker_target.setIcon(map_marker_target_icon);
                });
                jQuery(template_results).on('mouseout', 'li', function () {
                    map_marker_target = resultsPlaced['marker' + jQuery(this).data('clubId')];
                    map_marker_target_icon = setCustomPins(map_marker_target.content.status);
                    map_marker_target.setIcon(map_marker_target_icon);
                });
            }

            function setCustomPins(gymStatus, pinState) {
                let pinUrl = mapGlobalOptions.themeAssets + 'map-pin';
                if (gymStatus == 3) {
                    if (pinState === 'hover' || pinState === 'active') {
                        pinUrl += '-active';
                    }
                } else {
                    pinUrl += '-grey';
                    if (pinState === 'hover' || pinState === 'active') {
                        pinUrl += '-hover';
                    }
                }
                pinUrl += '.png';
                return {
                    scaledSize: new google.maps.Size(35, 56),
                    url: pinUrl
                };
            }

            function clearActiveClub() {
                resultsPicked = false;
                $passStep2.find('.wizard-results > li').each(function () {
                    $(this).removeClass('active');
                });
            }

            function setActiveClub(clubid, name, address, address2, city, country, state, state_abbr, zip, url, passlength, phone, email, temp_closed, no_ndaypass) {
                let resultAddress = address + (address2 ? ' ' + address2 : '') + '<br>' + city + ', ' + state + ' ' + zip;
                if (address_format) {
                    $.each(address_format, function (index, format) {
                        if (format.country_select === country) {
                            resultAddress = format.format.replace('{{address}}', address)
                                .replace('{{address2}}', address2 ? address2 : '')
                                .replace('{{city}}', city)
                                .replace('{{state}}', state)
                                .replace('{{state_abbr}}', state_abbr)
                                .replace('{{zip}}', zip)
                                .replace('{{country_abbr}}', country);
                        }
                    });
                }

                resultsPicked = true;
                if ($('.results-container').find('.error-msg').hasClass('active')) {
                    $('.results-container').find('.error-msg').removeClass('active');
                }
                $passStep3club.find('input[name="ClubId"]').val(clubid);
                $passStep3club.find('input[name="club_name"]').val(name);
                $passStep3club.find('input[name="club_address"]').val(address);
                $passStep3club.find('input[name="club_address1"]').val(address);
                $passStep3club.find('input[name="club_address2"]').val(address2);
                $passStep3club.find('input[name="club_city"]').val(city);
                $passStep3club.find('input[name="club_state"]').val(state);
                $passStep3club.find('input[name="club_zip"]').val(zip);
                $passStep3club.find('input[name="club_email"]').val(email);
                $passStep3club.find('input[name="club_phone"]').val(phone);

                if (formType == 'free-pass') {
                    $passStep3.find('.form-club-location').html(
                        (typeof selectedLocation != "undefined" && selectedLocation != '' ? '<h3 class="h6 h-underline form-selected-location">' + selectedLocation + '</h3>' : '') +
                        '<h5>' + name + '</h5>' +
                        '<p>' +
                        resultAddress + '<br />' +
                        ($("form input[name=referral_member_id]").length ? Html.tel(phone) + '<br />' : '') +
                        '</p>' +
                        ''
                    );
                    $passStep3.find('.location-region').closest('.form-group').remove();
                    if (temp_closed) {
                        $passStep3.find('.form-club-location').prepend('<div class="emergency-closed-hours">' + translations.temporarilyClosed + '</div>');
                    }
                    if (!!translations.emergencyClosureNotice.trim()) {
                        $passStep3.find('.form-club-location').append('<div class="emergency-closed-message">' + translations.emergencyClosureNotice + '</div>');
                    }
                    if (no_ndaypass) {
                        $passStep3.find('.form-header h2 + p small').hide();
                        let cancelLink = $passStep3.find('.form-body .form-footer .btn-cancel').outerHTML();
                        $passStep3.find('.form-body form').hide();
                        $passStep3.find('.form-body .form-emergency-notice').html('<div class="ndaypass-disabled">' + translations.nDayPassDisabled + '</div>' + cancelLink);
                    } else {
                        $passStep3.find('.form-body form').show();
                        $passStep3.find('.form-header h2 + p small').show();
                        $passStep3.find('.form-body .form-emergency-notice').html('');
                    }

                    AF.domUpdated();
                    let step3Headline = $passStep3.find('.form-headline').html(),
                        step3HeadlineOriginal = $passStep3.find('.form-headline').data('original-header'),
                        passValue = (passlength !== null && passlength > 0) ? passlength : '7';
                    step3Headline = step3Headline.replace('{{pass_length}}', passValue);
                    $passStep3.find('.form-headline').html(step3Headline);
                    $passStep3.find('.form-support .contact-direct').html(
                        '<a href="tel:' + phone + '">' + phone + '</a><br><a href="mailto:' + email + '">' + email + '</a>'
                    );
                    if (parseFloat(mapGlobalOptions.force_nday_pass_flow) === 1) {
                        if ($passStep3club.find('input[name="DigitalSource"]').val() != 'Web-Referral-Guest') {
                            $passStep3club.find('input[name="DigitalSource"]').val('Web-'+passValue+'day-'+passValue);
                        }
                        $passStep3.find('.form-headline').html(step3HeadlineOriginal.replace('{{pass_length}}', passValue));
                        if ($("#local_resident_modal").length) {
                            $('#local_resident_modal .form-modal__description').html($('#local_resident_modal .form-modal__description_original').html().replace('{{nday}}', passValue));
                        }
                        if ($("#page-headline").length) {
                            $("#page-headline").html($("#page-headline").data('old-header').replace('{{pass_length}}', passValue));
                        }
                    }
                    $("#form-club-7-day-pass").data( "pass-length", passValue );
                } else if (campaignForm == 'legacy') {
                    $passStep3.find('.form-club-location').html('<h5>' + name + '</h5><p>' + resultAddress + '<br />' + Html.tel(phone) + '<br /></p>');
                } else if (campaignForm == 'newton' || campaignForm == 'module') {
                    let passValue = (passlength !== null && passlength > 0) ? passlength : '7';
                    if ($passStep3.find('input[name="DigitalSource"]').data('originalValue') == 'Web-{{n}}day-FitnessPlus') {
                        $passStep3.find('input[name="DigitalSource"]').val('Web-'+passValue+'day-FitnessPlus');
                    } else if ($passStep3.find('input[name="DigitalSource"]').data('originalValue') == 'Web-{{n}}day-{{n}}') {
                        $passStep3.find('input[name="DigitalSource"]').val('Web-'+passValue+'day-'+passValue);
                    }
                    $passStep3.find('.form-club-location .gym-name').text(name);
                    $passStep3.find('.form-club-location .edit-location').attr('href','?location='+zip);
                    $passStep3.find('.form-club-location .text-disclaimer').html(resultAddress + '<br />' + Html.tel(phone));
                    if ($("#local_resident_modal").length) {
                        $('#local_resident_modal .form-modal__description').html($('#local_resident_modal .form-modal__description_original').html().replace('{{nday}}', passValue));
                    }
                    if (campaignForm == 'module') {$passStep3.find('.offer-form-fields h3').html($passStep3.find('.offer-form-fields h3').data('originalText').replace('{{n}}', passValue));}
                } else if (campaignForm == 'blackfriday' || campaignForm == 'seasonal') {
                    $passStep3.find('.form-club-location .gym-name').text(name);
                    $passStep3.find('.form-club-location .edit-location').attr('href','?location='+zip);
                    $passStep3.find('.form-club-location .text-disclaimer').html(resultAddress + '<br />' + Html.tel(phone));
                }
            }

            if (formType == 'campaign') {
                $(window).on("load", function () {
                    let selectedClubId = $('#campaignClubForm input[name=ClubId]').val();
                    if (selectedClubId != '') {
                        updateCustomCampaignLinks(selectedClubId);
                    }
                });
            }

            // Share Buttons
            $('#menu-landing-navigation-campaign li.twitter a, #menu-landing-navigation-campaign li.facebook a').click(function (e) {
                e.preventDefault();
                window.open(this.href, 'targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=700,height=500');
            });

            let currentUrl = new URL(window.location.href);
            if (currentUrl.searchParams.get('location')) {
                window.history.pushState('', '', currentUrl);
                searchQuery = $passLocationFinder.find('#locationFinderInput').val();
                checkLocation(searchQuery);
            }
            $(window).on('popstate', function (event) {
                if (history.state == null) {
                    backToStep1();
                } else if (history.state == 'step2') {
                    backToStep2();
                } else if (history.state == 'step3') {
                    backToStep3();
                }
            });

            function openInfoWindow(marker) {
                if (map_infowindow) {
                    map_infowindow.close();
                }

                let gym_content_status_text = '',
                    gym_content_address = marker.content.address + (marker.content.address2 !== null ? ' ' + marker.content.address2 : '') + '<br>' + marker.content.city + ', ' + marker.content.state_abbr,
                    gym_content_format_address = '';

                if (marker.content.status == 1) {
                    gym_content_status_text = ' ' + translations.comingSoon;
                } else if (marker.content.status == 2) {
                    gym_content_status_text = ' ' + translations.openingSoon;
                }

                if (mapGlobalOptions.address_format) {
                    jQuery.each(mapGlobalOptions.address_format, function () {
                        if (this.country_select === marker.content.country) {
                            gym_content_format_address = this.format.replace('{{address}}', marker.content.address)
                                .replace('{{address2}}', marker.content.address2 !== null ? marker.content.address2 : '')
                                .replace('{{city}}', marker.content.city)
                                .replace('{{state}}', marker.content.state)
                                .replace('{{state_abbr}}', marker.content.state_abbr)
                                .replace('{{zip}}', marker.content.zip)
                                .replace('{{country_abbr}}', marker.content.country);
                        }
                    });
                }

                if (gym_content_format_address) {
                    gym_content_address = gym_content_format_address;
                }

                let addr = gym_content_address ? ('\t<span class="address">' + gym_content_address + '</span><br>') : '',
                    clubMarker = new AFClub(AF.decodeClub(marker)),
                    infoWindowContent = '<div class="infowindow-content" data-club-id="' + marker.content.number + '">' +
                        '	<span class="name link-text"><a href="' + clubMarker.url + '">' + clubMarker.title + (gym_content_status_text ? ' ' + gym_content_status_text : '') + '</a></span>' +
                        '	<span class="address">' + addr + '</span>' +
                        '	<span class="phone">' + marker.content.phone + '</span>' +
                        '	<span class="links link-text">' +
                        '		<a target="_blank" href="' + clubMarker.passUrl + '" data-get-trial-pass-link>' + translations.getTrialPass + '</a> | ' +
                        '		<a class="linkVisitGym" href="' + (clubMarker.isLocalClub ? clubMarker.getVisitGymUrl() : '#') + '">' + (clubMarker.isLocalClub ? translations.visitThisGym : translations.visitAnytimeFitnessCountry.replace('{country_name}', translations.countries[clubMarker.countryAbbr])) + '</a>' +
                        '	</span>' +
                        '</div>';

                map_infowindow = new google.maps.InfoWindow({
                    content: infoWindowContent,
                    marker: marker.content.number
                });

                if (!clubMarker.isLocalClub) {
                    jQuery('body').on('click', `.infowindow-content[data-club-id=${clubMarker.id}] .linkVisitGym`, (e) => {
                        e.preventDefault();
                        getModal(clubMarker.id).show();
                    });
                }

                map_infowindow.open(mapResults, marker);

                google.maps.event.addListener(map_infowindow, 'closeclick', function () {
                    let map_marker_target = resultsPlaced['marker' + map_infowindow.marker],
                        map_marker_target_icon = setCustomPins(map_marker_target.content.status);
                    map_marker_target.active = false;
                    map_marker_target.setIcon(map_marker_target_icon);
                });
            };
            function getModal(afNumber) {
                if (!modals[afNumber]) {
                    modals[afNumber] = (new AFRedirectToClubSiteModal(afNumber));
                }
                return modals[afNumber]
            };
        }
    });
})(window.jQuery,window,document);

function updateCustomCampaignLinks(locationClubId) {
    jQuery('.campaign-content .custom-campaign-content a, .jancam-finePrint a').each(function(){
        jQuery(this).attr('href',function(i, href) {
            let newHref = href, replacement = "";
            if (newHref.includes('?club=') || newHref.includes('&club=')) {
                if (locationClubId != '') {
                    replacement = "$1"+locationClubId;
                } else {
                }
                newHref = href.replace(/([?|&]club=)[0-9a-zA-Z\-]*/g, replacement);
            } else {
                if (newHref.includes('?')) {
                    newHref += "&";
                } else {
                    newHref += "?";
                }
                newHref += 'club=' + locationClubId;
            }
            return newHref;
        });
    });
}